<template>
  <div class="text-center">
    <v-dialog width="500" v-model="showThisDialog">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Edit Holiday Request</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="$emit('closeEditRequestDialog')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container class="text-xs-center">
        <v-btn color="warning" block class="mb-4" @click="removeHolRequest(requestObj.ID)" :disabled="requestObj.actioned !== 0">Cancel Request</v-btn>
        <v-btn color="warning" block class="mb-4" @click="requestHolCancellation(requestObj.ID)" :disabled="requestObj.actioned !== 1 || isLessThan48HoursAway(requestObj.start) ">Request Holiday Cancellation</v-btn>
        <p v-if="isLessThan48HoursAway(requestObj.start)" style="color: #B50000;">Less than {{cancelHours}}hours before Holiday, cannot request cancellation.</p>
      </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import format from 'date-fns/format'
  import moment from 'moment'
  import axios from 'axios'
  export default {
    props: ['showDialog', 'requestObj'],
    data () {
      return {
        url: this.$store.getters.url,
        time: 9,
        user: this.$store.getters.user,
        company: this.$store.getters.company,
        dateConfirmed: false,
        cancelHours: parseInt(localStorage.getItem('cancel_hours')) || 48,
        showThisDialog: false
      }
    },
    computed: {
      filteredEndShiftTime () {
        if (this.time < 16) {
          return this.time + 8
        } else {
          return (this.time + 8) - 24
        }
      }
    },
    created () {
    },
    watch: {
      showDialog (val) {
        this.showThisDialog = val
      },
      showThisDialog (val) {
        if (!val) {
          this.$emit('closeEditRequestDialog')
        }
      }
    },
    methods: {
      isLessThan48HoursAway (date) {
        const now = new Date()
        const startDate = new Date(date)
        const diffInHours = (startDate - now) / 1000 / 60 / 60
        return diffInHours < this.cancelHours
      },
      formatDates (dateOne, dateTwo) {
        let formattedDates = ''
        if (dateOne) {
          formattedDates = format(dateOne, this.dateFormat)
        }
        if (dateTwo && dateTwo !== dateOne) {
          formattedDates += ' - ' + format(dateTwo, this.dateFormat)
        }
        return formattedDates
      },
      submitRequest () {
        const obj = {empID: this.user.empID, start: this.dateOne, end: this.dateTwo, time: this.time, company: this.company, date_requested: moment().format('YYYY-MM-DD HH:mm:ss')}
        axios.post(this.url + `/tanda-service/saveEmpHolRequest.ajax.php`, obj)
          .then(result => {
            this.$emit('requestSubmitted', obj)
            this.dateOne = ''
            this.dateTwo = ''
            this.dateConfirmed = false
          })
      },
      removeHolRequest (ID) {
        const obj = {company: this.company, empID: this.user.empID, cancellationID: ID, type: 0}
        axios.post(this.url + `/tanda-service/editEmpHolRequest.ajax.php`, obj)
          .then(result => {
            this.$emit('closeEditRequestDialog')
            this.$emit('requestSubmitted', obj)
            this.dateConfirmed = false
          })
      },
      requestHolCancellation (ID) {
        const obj = {company: this.company, empID: this.user.empID, cancellationID: ID, type: 1}
        axios.post(this.url + `/tanda-service/editEmpHolRequest.ajax.php`, obj)
          .then(result => {
            this.$emit('closeEditRequestDialog')
            this.$emit('requestSubmitted', obj)
            this.dateConfirmed = false
          })
      },
      allowedValues () {
        return 0
      }
    },
    filters: {
      filterTime (val) {
        if (val === 24) {
          return 0
        }
        return val
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/EditHolidayRequestDialog.vue